module.exports = __webpack_public_path__ + "assets/合汇LOGO-渐变.6711058e.svg";